import React, { useEffect, useState } from 'react';

import { useNavigationItems, useTinyBanner } from '@hooks/api';

import { Logo } from './assets';

import Header from './Header';

export default function HeaderContainer() {
  const { navigationItems } = useNavigationItems();
  const { tinyBanner } = useTinyBanner();

  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [hideTinyBanner, setHideTinyBanner] = useState(true);

  useEffect(() => {
    const getLoginStatus = async () => {
      const response = await fetch('/v1.1/status/', {
        method: 'HEAD'
      });

      setIsLoggedIn(
        response.headers.get('X-Authorized').toLowerCase?.() === 'true'
      );
    };

    const getTinyBannerStatus = async () => {
      const response = await fetch('/api/banners/', {
        method: 'GET'
      });

      const data = await response.json();

      setHideTinyBanner(data?.hidden);
    };

    getLoginStatus();
    getTinyBannerStatus();
  }, []);

  return (
    <Header
      navigationItems={navigationItems}
      hideTinyBanner={hideTinyBanner}
      tinyBanner={tinyBanner}
      headerLogo={
        <a href="/" className="flex flex-none items-center focus:outline-none">
          <Logo className="h-[24px] w-[118px] shrink-0" />
        </a>
      }
      isLoggedIn={isLoggedIn}
      options={{
        locale: window?.config?.iso_language_code || 'en-GB'
      }}
    />
  );
}
